import { render, staticRenderFns } from "./PayrollDashboardDetail.vue?vue&type=template&id=6259827e&scoped=true"
import script from "./PayrollDashboardDetail.vue?vue&type=script&lang=js"
export * from "./PayrollDashboardDetail.vue?vue&type=script&lang=js"
import style0 from "./PayrollDashboardDetail.vue?vue&type=style&index=0&id=6259827e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6259827e",
  null
  
)

export default component.exports